/**
 * @todo migrate AnalyticsEvents from Page Router
 * @see util/analytics/types.ts
 */

export const VRM_LOOKUP_MODAL_OPENED = 'VRM_LOOKUP_MODAL_OPENED';
